import { apiClient } from './client'

export type ChatMessage = {
  role: 'user' | 'assistant' | 'system'
  content: string
}

export type ChatCompletionRequest = {
  messages: ChatMessage[]
  systemPromptId?: string
  model?: string
  mobileUserId?: string
}

export type MobileUserSummary = {
  id: string
  userId: string
  username?: string
  hasOnboardingData: boolean
  displayName: string
}

export type ChatUsage = {
  promptTokens: number
  completionTokens: number
  totalTokens: number
}

export type ChatCompletionResponse = {
  id: string
  model: string
  message: ChatMessage
  usage?: ChatUsage
}

export type ChatStatusResponse = {
  isConfigured: boolean
  defaultModel: string
  activePromptId?: string | null
}

export type ChatPromptPreviewResponse = {
  prompt: string
}

/**
 * Check if the chat service is configured and available
 */
export async function getChatStatus() {
  const { data } = await apiClient.get<ChatStatusResponse>('/api/admin/chat/status')
  return data
}

/**
 * Send a chat message and get a response
 */
export async function sendChatMessage(
  messages: ChatMessage[],
  options?: { systemPromptId?: string; model?: string; mobileUserId?: string }
) {
  const request: ChatCompletionRequest = {
    messages,
    ...options
  }
  const { data } = await apiClient.post<ChatCompletionResponse>('/api/admin/chat/completions', request)
  return data
}

/**
 * Get list of mobile users for context selection
 */
export async function getMobileUsers() {
  const { data } = await apiClient.get<MobileUserSummary[]>('/api/admin/chat/mobile-users')
  return data
}

/**
 * Preview the full system prompt, including any injected user context
 */
export async function getPromptPreview(options?: { systemPromptId?: string; mobileUserId?: string }) {
  const { data } = await apiClient.get<ChatPromptPreviewResponse>('/api/admin/chat/prompt-preview', {
    params: {
      systemPromptId: options?.systemPromptId,
      mobileUserId: options?.mobileUserId
    }
  })
  return data
}
